import React, { useEffect, useState } from "react";

export default function FeedbackModal({ show, onClose, submissionId, organizationName, affiliateMemberId }) {
  const [feedbacks, setFeedbacks] = useState([]);

  const fetchUrl = `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_submissions/${submissionId}/feedback_index`;

  useEffect(() => {
    if (show) {
      fetch(fetchUrl)
        .then((res) => res.json())
        .then((data) => setFeedbacks(data.feedbacks))
        .catch((err) => console.error("Error loading feedbacks", err));
    }
  }, [show, fetchUrl]);

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      id="facility-form-submission-view-feedback-modal"
      role="dialog"
      aria-labelledby="facility_form_submission_view_feedback"
      aria-hidden={!show}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">View Feedback Message(s)</h5>
            <button type="button" className="close" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {feedbacks.length === 0 ? (
              <p>No feedback messages available.</p>
            ) : (
              feedbacks.map((feedback) => (
                <div key={feedback.id} className="mb-4">
                  <h6>
                    Message sent by {feedback.sender_name} at{" "}
                    {new Date(feedback.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} on{" "}
                    {new Date(feedback.created_at).toLocaleDateString()}
                  </h6>
                  <div className="card p-3 bg-light border">
                    <div className="card-block py-6 pr-6 ">
                      <p className="text-break">{feedback.content}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={onClose}
            >
              Close
            </button>
          </div>

        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1}}></div>
    </div>
  );
}
